import axios from 'axios'

export const state = {
  general_config: {}
}

export const getters = {
  getGeneralConfig: state => { return state.general_config }
}

export const mutations = {
  setGeneralConfig (state, payload) { state.general_config = payload }
}

export const actions = {
  loadGeneralConfig ({ commit }, payload) {
    const uri = '/api/general_configs'
    axios.get(uri)
        .then(response => { commit('setGeneralConfig', response.data) })
        .catch(err => { console.log('Organizations error ', err) })
  },

  storeGeneralConfig ({ commit }, payload) {
    const uri = '/api/general_configs'
    const config = { headers: { 'content-type': 'multipart/form-data' }}

    const objet = new FormData()
    objet.append('logo_url', payload.logo_url)
    objet.append('app_name', payload.app_name)
    objet.append('company_name', payload.company_name)
    objet.append('country_id', payload.country_id)
    objet.append('address', payload.address)
    objet.append('mail_subject', payload.mail_subject)
    objet.append('mail_address', payload.mail_address)

    axios.post(uri, objet, config)
        .then(response => { commit('setGeneralConfig', response.data) })
        .catch(err => { console.log('New general config error ', err) })
  },

  async updateGeneralConfig ({ commit }, payload) {
    const uri = '/api/general_configs'
    const uri_delete = '/api/general_configs/' + payload.id
    const config = { headers: { 'content-type': 'multipart/form-data' }}

    await axios.delete(uri_delete)
        .then(response => { })
        .catch(err => { console.log('Delete general config error ', err) })

    const objet = new FormData()
    objet.append('logo_url', payload.logo_url)
    objet.append('app_name', payload.app_name)
    objet.append('company_name', payload.company_name)
    objet.append('country_id', payload.country_id)
    objet.append('address', payload.address)
    objet.append('mail_subject', payload.mail_subject)
    objet.append('mail_address', payload.mail_address)

    axios.post(uri, objet, config)
        .then(response => { commit('setGeneralConfig', response.data) })
        .catch(err => { console.log('New general config error ', err) })

    /* const uri = '/api/general_configs/'+payload.id;
    const config = { headers: { 'content-type': 'multipart/form-data' } };

    let objet = new FormData();
    objet.append('id', payload.id);
    objet.append('logo_url', payload.logo_url);
    objet.append('app_name', payload.app_name);
    objet.append('company_name', payload.company_name);
    objet.append('country_id', payload.country_id);
    objet.append('address', payload.address);
    objet.append('mail_subject', payload.mail_subject);
    objet.append('mail_address', payload.mail_address);
    objet.append('card_template_id', payload.card_template_id);

    axios.put(uri, objet, config)
        .then(response => { commit('setGeneralConfig', response.data) })
        .catch(err => { console.log('Update general config error ', err) })*/
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/general_config.js